var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('label',{attrs:{"for":_vm.id}},[_vm._v("\n  "+_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger ml-1"},[_vm._v("*")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83fa6996","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormFields/Base/FLabel.vue
// module id = 766
// module chunks = 30